<form>
	<ui-modal [modalTitle]="title" [scrollable]="!noScroll" size="xl" [overflowVisible]="noScroll" [showBackButton]="step === 'edit'" (back)="backToSelection()">

		<div ui-modal-sticky-header>
			<p *ngIf="step === 'select'" class="text-secondary mb-0 pt-3 pb-2">Select the subtasks you want to edit together, then continue.</p>
			<p *ngIf="step === 'edit'" class="text-secondary mb-0 pt-3 pb-2">Editing {{ selectedRows.length }} subtask{{ selectedRows.length === 1 ? '' : 's' }}. Completed dependencies are locked and cannot be removed.</p>
		</div>

		<ng-container *ngIf="step === 'select'">
			<table class="table table-hover vam m-0">
				<tbody>
					<ng-container *ngFor="let group of groups">
						<tr class="no-border bg-light selectable" (click)="toggleGroupCollapsed(group)">
							<td class="shrink pr-0" (click)="$event.stopPropagation()">
								<label class="custom-control custom-checkbox m-0" ngbTooltip="Select all in this group">
									<input type="checkbox" class="custom-control-input" [ngModel]="isGroupAllSelected(group)" (ngModelChange)="toggleGroupSelection(group)" [ngModelOptions]="{ standalone: true }">
									<span class="custom-control-label"></span>
								</label>
							</td>
							<td class="pl-0 py-2" colspan="2">
								<div class="d-flex align-items-center">
									<div class="flex-weight-1 text-bold">
										<i class="wq text-large mr-1" [ngClass]="{ 'wq-caret-down': !group.collapsed, 'wq-caret-up': group.collapsed }"></i>
										{{ (group.group_key === 'null' || !group.group_key) ? 'Unassigned' : group.group_key }}
									</div>
									<div class="mr-4">
										<span style="font-size: 0.7rem;" class="badge bg-success-25 text-success mr-2 p-2">{{ group.completed }} / {{ group.total }}</span>
										<span class="text-secondary text-small">Subtasks Completed</span>
									</div>
									<div *ngIf="group.dependencies?.length">
										<i class="wq wq-dependency-photo" [ngClass]="{ 'text-primary': getCompletedDependencies(group.dependencies) > 0, 'text-secondary': getCompletedDependencies(group.dependencies) === 0 }"></i>
										<span class="text-small text-secondary ml-1">
											<span [ngClass]="{ 'text-primary': getCompletedDependencies(group.dependencies) > 0 }">{{ getCompletedDependencies(group.dependencies) }}</span>
											/ {{ group.dependencies.length }}
										</span>
									</div>
								</div>
							</td>
						</tr>
						<ng-container *ngIf="!group.collapsed">
							<tr *ngFor="let row of group.rows" class="selectable" [ngClass]="{ 'bg-primary-10': row.selected }" (click)="toggleRow(row)">
								<td class="shrink pr-0 pl-4">
									<label class="custom-control custom-checkbox m-0" (click)="$event.stopPropagation()">
										<input type="checkbox" class="custom-control-input" [ngModel]="row.selected" (ngModelChange)="row.selected = $event" [ngModelOptions]="{ standalone: true }">
										<span class="custom-control-label"></span>
									</label>
								</td>
								<td class="shrink pr-0">
									<div *ngIf="row.image_url" class="product-image w-2r h-2r my-n1" [style.backgroundImage]="'url(\'' + row.image_url + '\')' | safeStyle"></div>
								</td>
								<td>
									<div class="text-lines lines-1 text-bold" uiEllipsisTooltip>{{ row.name }}</div>
									<div class="d-flex align-items-center flex-wrap mt-1">
										<span *ngIf="row.area && group.group_key !== row.area" class="badge badge-lightgrey text-no-transform text-normal mr-1">{{ row.area }}</span>
										<span *ngIf="row.category && group.group_key !== row.category" class="badge badge-lightgrey text-no-transform text-normal mr-1">{{ row.category }}</span>
										<ui-task-priority [priority]="row.priority"></ui-task-priority>
									</div>
								</td>
							</tr>
						</ng-container>
					</ng-container>
				</tbody>
			</table>
		</ng-container>

		<ng-container *ngIf="step === 'edit'">
			<ng-template #taskLine let-row let-last="last">
				<div [ngClass]="{ 'border-bottom border-lightgrey': !last }">
					<div class="d-flex p-3">
						<div class="w-4r">
							<div *ngIf="row.image_url" class="product-image" [style.backgroundImage]="'url(\'' + row.image_url + '\')' | safeStyle"></div>
						</div>
						<div class="flex-weight-1">
							<div class="d-flex">
								<div class="w-20r mr-3">
									<input class="form-control d-inline-block" [ngClass]="{ 'border-primary bg-primary-10': isSelectedInput(row, 'name') || !('' + row.name).trim() }" placeholder="Task name" (change)="checkForChangedProperties('name', row)" [(ngModel)]="row.name" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
									<textarea rows="2" class="form-control mt-2" [ngClass]="{ 'border-primary bg-primary-10': isSelectedInput(row, 'description') }" placeholder="Task description" [(ngModel)]="row.description" (change)="checkForChangedProperties('description', row)" [ngModelOptions]="{ standalone: true }"></textarea>
								</div>

								<div class="flex-weight-1">
									<div class="d-flex">
										<input class="form-control w-5r d-inline-block mr-1" [ngClass]="{ 'border-primary bg-primary-10': isSelectedInput(row, 'duration') }" [(ngModel)]="row.duration" (change)="durationChanged(row)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">

										<select class="custom-select w-auto mr-3" [ngClass]="{ 'border-primary bg-primary-10': isSelectedInput(row, 'duration_type') }" [(ngModel)]="row.duration_type" [ngModelOptions]="{ standalone: true }" (change)="checkForChangedProperties('duration_type', row)">
											<option value="min">mins</option>
											<option value="hour">hours</option>
										</select>
									</div>
									<div class="mt-2 d-flex align-items-center">
										<select class="custom-select w-auto mr-3" [ngClass]="{ 'border-primary bg-primary-10': isSelectedInput(row, 'priority') }" [(ngModel)]="row.priority" [ngModelOptions]="{ standalone: true }" (change)="checkForChangedProperties('priority', row)">
											<option value="0">Low</option>
											<option value="1">Medium</option>
											<option value="2">High</option>
										</select>
										<ui-checkbox-dropdown *ngIf="dependencyOptions.length" class="flex-weight-1" [classProp]="{ 'border-primary bg-primary-10': isSelectedInput(row, 'dependencies') }" dropdownName="Dependencies" [items]="dependencyOptions" [maxShown]="1" selectProp="id" [selectedItems]="row.dependencyIds" [lockedItems]="row.lockedDependencyIds" (selectionChange)="rowDependencyChange($event, row)"></ui-checkbox-dropdown>
									</div>
									<div *ngIf="hasDependencyOverride(row)" class="text-primary text-small mt-1"><i class="wq wq-info mr-1"></i>Overridden — dependencies changed from the original selection. Completed dependencies are kept.</div>
								</div>
							</div>
						</div>
						<div class="ml-3 text-right shrink">
							<span *ngIf="row.category" class="badge badge-lightgrey text-no-transform text-normal mb-1">{{ row.category }}</span>
							<span *ngIf="row.area" class="badge badge-lightgrey text-no-transform text-normal mb-1">{{ row.area }}</span>
						</div>
						<div class="ml-3">
							<button type="button" class="btn btn-outline-secondary btn-sm px-1 border-0" (click)="removeRow(row)" ngbTooltip="Remove from list"><i class="wq wq-close"></i></button>
						</div>
					</div>

					<div *ngIf="commonDiffLines.length - 1 > 0 && row.id === lastChangedItemId" class="alert alert-info ml-2">
						<div class="d-flex align-items-center">
							<div class="flex-weight-1 mr-3">
								<i class="wq wq-info mr-1"></i> There {{ commonDiffLines.length - 1 === 1 ? 'is' : 'are' }}
								<b>{{ commonDiffLines.length - 1 }} similar {{ commonDiffLines.length - 1 === 1 ? 'subtask' : 'subtasks' }}</b> with different
								<span class="text-bold" *ngFor="let val of changedProperties; let last = last">{{ propertiesMap[val] }}{{ !last ? ', ' : '' }}</span>.
							</div>
							<div class="text-bold mr-3 selectable" (click)="cancelUpdate()">Cancel</div>
							<button type="button" class="btn btn-secondary mr-2" (click)="bulkUpdateAllCommonProperties()">Update all ({{ selectedRows.length }})</button>
							<button type="button" class="btn btn-primary" (click)="bulkUpdateCommonProperties()">Update ({{ commonDiffLines.length - 1 }}) similar</button>
						</div>
					</div>
				</div>
			</ng-template>

			<ng-container *ngFor="let row of selectedRows; let last = last">
				<ng-container *ngTemplateOutlet="taskLine; context: { $implicit: row, last }"></ng-container>
			</ng-container>
		</ng-container>

		<button *ngIf="step === 'select'" type="button" class="btn btn-medium" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button *ngIf="step === 'select'" type="button" class="btn btn-primary" (click)="confirmSelection()" [disabled]="disabled || !selectedRows.length" ui-modal-footer>Confirm ({{ selectedRows.length }})</button>
		<button *ngIf="step === 'edit'" type="button" class="btn btn-medium" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button *ngIf="step === 'edit'" type="submit" class="btn btn-primary" (click)="save()" [disabled]="disabled || !selectedRows.length" ui-modal-footer>Save</button>
	</ui-modal>
</form>
